import { render, staticRenderFns } from "./buildingPharmacyLocationSetupList.vue?vue&type=template&id=4039c69e&"
import script from "./buildingPharmacyLocationSetupList.vue?vue&type=script&lang=js&"
export * from "./buildingPharmacyLocationSetupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports